import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Typography from '../Typography';

import styles from './PageHeader.less';

const cxb = cx.bind(styles);

/**
 * **Access:**
 * ```js
 * import { Navigation } from '@iss/client-react-components'
 *
 * ...
 * render () {
 * 	return <Navigation.PageHeader .../>
 * }
 * ```
 *
 * Standard Page Header component.
 *
 * Children of this component will be rendered in the right most sub-section.
 *
 * @class PageHeader
 */
export default class PageHeader extends React.PureComponent {
  static propTypes = {
    /** @ignore */
    children: PropTypes.any,

    /** @ignore */
    className: PropTypes.string,

    /**
     * The title text or renderable node to be rendered in the left most zone of the header.
     */
    title: PropTypes.node.isRequired,

    /**
     * The content for the sub-text (middle zone) of the header.
     *
     */
    text: PropTypes.node,
  };

  render() {
    const { children, className, title, text } = this.props;

    const titleContent =
      typeof title === 'string' ? <Typography.Heading1 className={cxb('title')}>{title}</Typography.Heading1> : title;

    return (
      <div className={cx(className, cxb('root'))}>
        {titleContent}
        <Typography.SubText1 className={cxb('text')}>{text}</Typography.SubText1>
        <div className={cxb('controls')} {...{ children }} />
      </div>
    );
  }
}
